import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { notification } from 'antd';
import { AcquireToken, CatchAuthError} from '../auth/authInstance';
// import { AuthResponse } from 'msal';
import { ErrorCodes } from './utils';
import {User} from 'oidc-client'

import i18n from "@src/locales";
// import Store from '@redux/store';
// import { UpdateTimeStampOfCallingAPIAction } from '@redux/actions';

// const { warning } = Modal;

const AxiosInstance = axios.create({
  xsrfCookieName: 'xsrf-token',
  // baseURL: process.env.REACT_APP_API_URL,
  // timeout: 1 * 60 * 1000
});
const AxiosDowloadInstance = axios.create({
  xsrfCookieName: 'xsrf-token',
});

const CleanAxiosInstance = axios.create({
  xsrfCookieName: 'xsrf-token',
  // baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000
});

interface responseModel {
  success: boolean,
  message: string,
  data: any
}

const CancelTokenSource = () => {
  return axios.CancelToken.source();
}

const IsCancel = (error: any) => {
  return axios.isCancel(error);
}


// const onFulfilled = async (config: AxiosRequestConfig) => {
//   const { headers } = config;
//   const res :User= await AcquireToken().then(res => {
//     return res;
//   }, (error) => {
//     // console.error(error, error?.name);
//     CatchAuthError(error);
//     return {} as any;
//   });

//   var token = res.id_token;
//   if (!token) {
//     console.log('acquire token error when calling api')
//   }

//   // Store.dispatch(UpdateTimeStampOfCallingAPIAction(new Date().getTime()));
//   //token ="eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Il9DSkFPdHlzWVZtNXhjMVlvSzBvUTdxeUJDUSIsImtpZCI6Il9DSkFPdHlzWVZtNXhjMVlvSzBvUTdxeUJDUSJ9.eyJhdWQiOiJodHRwczovL2dyYXBoLmNoaW5hY2xvdWRhcGkuY24iLCJpc3MiOiJodHRwczovL3N0cy5jaGluYWNsb3VkYXBpLmNuL2UwODAzODViLTlmOGMtNDBhYy1iYWFkLTBiZjk0MWYyYTZhNy8iLCJpYXQiOjE2MzI4MDAyODYsIm5iZiI6MTYzMjgwMDI4NiwiZXhwIjoxNjMyODA0MTg2LCJhY3IiOiIxIiwiYWlvIjoiQVRRQXkvOEtBQUFBVlcwVGdoNXBSUEFiMUt4N2o5YmI2K1QwbE9iZnMrdmhHQzYvY1YrN0dhS05PdzMzOTFSalRuUng5WCt3YlR5diIsImFtciI6WyJwd2QiXSwiYXBwaWQiOiIxOGFlNjU4OS01NjNjLTQxNmEtOGFkYS0zY2I4MWVmMzQ0OTYiLCJhcHBpZGFjciI6IjAiLCJpcGFkZHIiOiI1OC4zNy4yLjk1IiwibmFtZSI6InRlc3R1c2VyIiwib2lkIjoiYTIzM2I4MjMtZjhlMi00YWJkLThlNmMtOWEzZmMzODY5ZDE1IiwicHVpZCI6IjIwMDNCRkZEODE3MDczQ0QiLCJyaCI6IjAuQUFBQVd6aUE0SXlmckVDNnJRdjVRZkttcDRsbHJoZzhWbXBCaXRvOHVCN3pSSllCQURzLiIsInNjcCI6IlVzZXIuUmVhZCIsInN1YiI6InIwLWEya3dzZ2h3RGlSSzlMc1hlV3FNNV9vYnVDT1BHZEZjd2dDXzlnOUUiLCJ0aWQiOiJlMDgwMzg1Yi05ZjhjLTQwYWMtYmFhZC0wYmY5NDFmMmE2YTciLCJ1bmlxdWVfbmFtZSI6InRlc3R1c2VyQGJjcmRjLnBhcnRuZXIub25tc2NoaW5hLmNuIiwidXBuIjoidGVzdHVzZXJAYmNyZGMucGFydG5lci5vbm1zY2hpbmEuY24iLCJ1dGkiOiJ3bnVxdE03QU8wVzM5enhUcWFveEFBIiwidmVyIjoiMS4wIn0.vCpjVeRETMKWGikoINLjokeiTYBPWWD70Cqb814xYBGDY2zE6Og5v4tLg_BdRW57MUE6jK-Imrt-XH1mOMobQXLTucJedTfs_TQqdKcx4Ir2hpz-FYf8ZA8ploTYf1uBntWk8EVbmBP_ySXp7dzXf3eI_0i-hdJF_x_xK-rfRju9ZKWv32cEbib9lM2ksUAaa5NWMDHSdyjD6iF2QLBFKslGb1L99f2aRAfRN0fZx4lCoGGUcH7AK4n9T1ctidbrSQ09gzAUFasKjbpV64zDEpOC6FOhO2X-qZbRJFLbRuRNzEOKj-kWQeAiG-jA5oPqTEoH4AGuAuO32p2lmI7-hw";
//   return {
//     ...config,
//     headers: {
//       ...headers,
//       'Authorization': `Bearer ${token}`
//     }
//   };
// }
const onFulfilled = async (config: AxiosRequestConfig) => {
  const { headers } = config;

  var token = localStorage.getItem('jt');
  if (!token) {
    console.log('acquire token error when calling api')
  }

  return {
    ...config,
    headers: {
      ...headers,
      'Authorization': `Bearer ${token}`
    }
  };
}

AxiosInstance.interceptors.request.use(onFulfilled, (error) => {
  // console.log(error)
  return Promise.reject(error);
});

AxiosInstance.interceptors.response.use((res: AxiosResponse<responseModel>) => {
  if(res.data){
    const { success, message, data } = res.data;
    if (Object.prototype.hasOwnProperty.call(res.data, 'success')) {
      if (!success) {
        // console.log(message)
        notification.warning({ message });
        return Promise.reject(data);
      } else {
        return Promise.resolve(data);
      }
    } else {
      return Promise.resolve(res.data);
    }
  }else{
    return Promise.resolve(res.data );
  }

}, (error) => {
  if (!axios.isCancel(error)) {
    handleError(error);
  }
  return Promise.reject(error);
});


function handleError(res: any) {
  if (res && res.response) {
    const status: number = res.response.status;
    const { message } = res.response.data || {};
    const msg = message || ErrorCodes[status] || (i18n.language === 'zh' ? '请求失败' : 'Request failed');

    switch (status) {
      case 401:
        notification.warning({
          message: i18n.language === 'zh' ? '登录已过期' : 'Login expired',
          description: `${status}： ${msg}`
        });
        localStorage.removeItem('jt');
        window.location.href = "/login";
        // MSALObjLogout();
        // window.location.href=window.location.origin
        // AcquireToken().then(res => {
        //   return res;
        // }, (error) => {
        //   // console.error(error, error?.name);
        //   CatchAuthError(error);
       
        //   return {} as any;
        // });
       
         break;
      default:
        notification.warning({
          message: i18n.language === 'zh' ? '系统提示' : 'System prompt',
          description: `${msg}`
        });
    }

  } else {
    notification.error({
      message: i18n.language === 'zh' ? '系统提示' : 'System prompt',
      description: i18n.language === 'zh' ? '请求失败' : 'Request failed'
    });
  }

}


export { CleanAxiosInstance, AxiosInstance, CancelTokenSource, IsCancel };

